import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { connect } from 'react-redux'

import '../style/summary.scss'

import { animateScrollToTop } from '../utils/main'

import { APP_ENDPOINTS, APP_BASENAME } from '../store/reducers/statics/consts'
//import { formatStringAsNumber, limitNumTo2AfterDot } from '../utils/main'
import { getAllItemsSummary } from '../store/actions/SummaryActions'

class Summary extends Component {

    generateNextBtnURL() {
        const { step } = this.props.match.params;
        const indexOfCurStep = APP_ENDPOINTS.indexOf(step);
        const newIndex = indexOfCurStep >= APP_ENDPOINTS.length - 1 ? false : indexOfCurStep + 1;
        return newIndex ? `/${APP_BASENAME}/${APP_ENDPOINTS[newIndex]}` : false;
    }

    calculateSummary() {
        /*const { PlansReducer, DIDsReducer, HostedPbxReducer, DialingPlansReducer, EquipmentReducer } = this.props;
        const { DIDsAdded, bulkPackagesSelected } = DIDsReducer;
        const { HostedPbxPlan } = HostedPbxReducer;
        const { DialingPlan, AddOnFeatures } = DialingPlansReducer;
        const { EquipmentSelected, EquipmentInfo } = EquipmentReducer;
        
        var total = 0;
        var didSelectBulkSMS = false;

        Object.keys(bulkPackagesSelected).forEach(key => {
            const item = bulkPackagesSelected[key];
            const packagePrice = Number(PlansReducer.bulkPackages.find(el => el.id == key).price.replace(/,/g, ''));
            if(item && item > 0) {
                total += item * packagePrice;
                didSelectBulkSMS = true;
            }
        });

        DIDsAdded.forEach(item => {
            total += item[411] ? 5.98 : 0;
            total += item.E911 ? 5.99 : 0;
            total += item.CName ? 2.99 : 0;
            total += item.price ? item.price : 0.99;
            total += item.isUnlimited && !didSelectBulkSMS ? 4.99 : 0;
        });

        total += HostedPbxPlan.price;

        total += DialingPlan.isUnlimited ? 
            (DialingPlan.quantity ? 
                (DialingPlan.quantity * (Number(DialingPlan.quantity) >= 5 ? 19.99 : 24.99))
                :
                0
            )
            :
            (DialingPlan.price);

        AddOnFeatures.forEach(item => {
            total += item.price;
        })

        Object.keys(EquipmentSelected).map(key => {
            const count = EquipmentSelected[key];
            if(count > 0) {
                Object.keys(EquipmentInfo).find(subKey => {
                    const item = EquipmentInfo[subKey].find(el => el.id == key);
                    if(item) {
                        total += item.price * count;
                        return true;
                    }
                });
            }
        })*/

        // return formatStringAsNumber(limitNumTo2AfterDot(total));
        return this.props.getAllItemsSummary();
    }

    render() {
        const nextBtnURL = this.generateNextBtnURL();
        const summary = `$${this.calculateSummary()}`;

        return (
            <div id="summary">
                <div className="content-holder">
                    <div className="content">
                        <div id="sum-amount">Summary: {summary}</div>
                        <div className="btns-holder">
                            {
                                nextBtnURL &&
                                <Link to={nextBtnURL} onClick={() => animateScrollToTop()}>
                                    <div className="btn" style={{marginRight: "1rem"}}>
                                        Next
                                    </div>
                                </Link>
                            }
                            <a href="https://voipdialing.com/cart">
                                <div className="btn">Checkout</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state,
        /*PlansReducer: state.PlansReducer,
        DIDsReducer: state.DIDsReducer,
        HostedPbxReducer: state.HostedPbxReducer,
        DialingPlansReducer: state.DialingPlansReducer,
        EquipmentReducer: state.EquipmentReducer,*/
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getAllItemsSummary: () => dispatch(getAllItemsSummary()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary);